import React from "react"
import Alerts from "../Alerts"
import Sidebar from "./Sidebar"
import Header from "./Header"
import ContentWrapper from "./ContentWrapper"
import Agreement from "./Agreement"
// Styles, images
import "../../styles/layouts"
import { ContainerProps } from "./types"

const Container: React.FC<ContainerProps> = (props) => {
  const place = JSON.parse(props.place)
  return (
    <React.Fragment>
      <Alerts error={props.error} notice={props.notice} />
      <Header
        paths={props.menuPaths}
        selected={props.contentType}
        availableMenus={props.availableMenus}
      />
      <div className="l-flex">
        <Sidebar
          paths={props.menuPaths}
          selected={props.contentType}
          availableMenus={props.availableMenus}
        />
        <ContentWrapper
          {...props}
          place={place}
          contentType={props.contentType}
          contentParams={props.contentParams}
        />
      </div>
      <Agreement accepted={props.termsAccepted} />
    </React.Fragment>
  )
}
export default Container
